"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorySearchFilter = exports.CategorySortFilter = exports.CategorySymbolCountFilter = exports.CategoryPriceSearchFilter = exports.CategoryNameSearchFilter = void 0;
const typedi_1 = require("typedi");
/**
 * Фильтр поиска по подстроке
 */
class CategoryNameSearchFilter {
    constructor() {
        /**
         * Тип поискового запроса
         */
        this.type = '';
        /**
         * Поисковый запрос
         */
        this.search = '';
    }
    /**
     * Восстанавливает фильтр из ввода пользователя
     */
    fromFilters(params) {
        var _a;
        ((_a = params.get('filter')) !== null && _a !== void 0 ? _a : '').split(',').forEach((chunk) => {
            let chunks = chunk.split('.');
            if (chunks[0] === 'word') {
                this.type = chunks[1];
                this.search = chunks[2];
            }
        });
    }
    /**
     * Формирует фильтр ля запроса к API
     */
    toApi() {
        return {
            searchType: this.type,
            searchString: this.search,
        };
    }
}
exports.CategoryNameSearchFilter = CategoryNameSearchFilter;
/**
 * Фильтр поиска по цене
 */
class CategoryPriceSearchFilter {
    constructor() {
        /**
         * Минимальная цена
         */
        this.minPrice = '';
        /**
         * Максимальная цена
         */
        this.maxPrice = '';
    }
    /**
     * Восстанавливает фильтр из ввода пользователя
     */
    fromFilters(params) {
        var _a;
        ((_a = params.get('filter')) !== null && _a !== void 0 ? _a : '').split(',').forEach((chunk) => {
            let chunks = chunk.split('.');
            if (chunks[0] === 'price') {
                [this.minPrice, this.maxPrice] = chunks[1].split('-');
            }
        });
    }
    /**
     * Формирует фильтр ля запроса к API
     */
    toApi() {
        return {
            priceMin: this.minPrice,
            priceMax: this.maxPrice
        };
    }
}
exports.CategoryPriceSearchFilter = CategoryPriceSearchFilter;
/**
 * Фильтр по длине доменного имени
 */
class CategorySymbolCountFilter {
    constructor() {
        /**
         * Минимальная длина
         */
        this.minCount = '';
        /**
         * Максимальная длина
         */
        this.maxCount = '';
    }
    /**
     * Восстанавливает фильтр из ввода пользователя
     */
    fromFilters(params) {
        var _a;
        ((_a = params.get('filter')) !== null && _a !== void 0 ? _a : '').split(',').forEach((chunk) => {
            let chunks = chunk.split('.');
            if (chunks[0] === 'letter') {
                [this.minCount, this.maxCount] = chunks[1].split('-');
            }
        });
    }
    /**
     * Формирует фильтр ля запроса к API
     */
    toApi() {
        return {
            letterMin: this.minCount,
            letterMax: this.maxCount
        };
    }
}
exports.CategorySymbolCountFilter = CategorySymbolCountFilter;
/**
 * Фильтр сортировки
 */
class CategorySortFilter {
    constructor() {
        /**
         * Поле сортировки
         */
        this.field = '';
        /**
         * Направление сортировки
         */
        this.order = '';
    }
    /**
     * Восстанавливает фильтр из ввода пользователя
     */
    fromFilters(params) {
        var _a, _b, _c;
        const array = new String((_a = params.get('sort')) !== null && _a !== void 0 ? _a : '').split('_');
        this.field = (_b = array[0]) !== null && _b !== void 0 ? _b : '';
        this.order = (_c = array[1]) !== null && _c !== void 0 ? _c : '';
    }
    /**
     * Формирует фильтр ля запроса к API
     */
    toApi() {
        return {
            sort: this.field,
            sortOrder: this.order
        };
    }
}
exports.CategorySortFilter = CategorySortFilter;
/**
 * Фильтр поиска по категории
 */
let CategorySearchFilter = class CategorySearchFilter {
    /**
     * Конструктор
     */
    constructor() {
        /**
         * Фильтр поиска по имени
         */
        this.search = new CategoryNameSearchFilter();
        /**
         * Фильтр поиска по цене
         */
        this.price = new CategoryPriceSearchFilter();
        /**
         * Фильтр поиска по длине домена
         */
        this.symbolCount = new CategorySymbolCountFilter();
        /**
         * Фильтр сортировки
         */
        this.sort = new CategorySortFilter();
        /**
         * Лимит выборки
         */
        this.limit = 18;
        /**
         * Смещение выборки
         */
        this.offset = 0;
        this.init();
    }
    /**
     * Формирует фильтр ля запроса к API
     */
    toApi() {
        let out = {
            id: this.categoryId,
            limit: this.limit,
            offset: this.offset,
        };
        [this.search, this.price, this.symbolCount, this.sort].
            forEach((filter) => { out = Object.assign(Object.assign({}, out), filter.toApi()); });
        return out;
    }
    /**
     * Устанавливает идентификатор категории
     */
    setCategoryId(categoryId) {
        this.categoryId = categoryId;
    }
    /**
     * Инициализирует состояние
     */
    init() {
        this.fromFilters();
    }
    /**
     * Увеличивает смещение
     */
    increaseOffset() {
        this.offset += this.limit;
    }
    /**
     * Восстанавливает фильтр из ввода пользователя
     */
    fromFilters() {
        const params = new URLSearchParams(window.location.search);
        const out = {};
        // const applier = (filter: CategorySubFilter): void => {filter.fromFilters(params);}
        [this.search, this.price, this.symbolCount, this.sort].forEach((filter) => { filter.fromFilters(params); });
    }
    /**
     * Отдает значение поля поиска
     */
    getSearchString() {
        return this.search.toApi().searchString;
    }
};
CategorySearchFilter = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], CategorySearchFilter);
exports.CategorySearchFilter = CategorySearchFilter;
